module.exports = __webpack_public_path__ + "static/media/stereo.6665ae64.svg";